import { useState } from "react";

const imgFolder = "./img/exterior/";

function VehicleImage({ model, color, rim }) {
  const imgName = `${model.key}/${color.key}_${rim.key}.png`;

  return (
    <img
      className="car-interior-image"
      src={`${imgFolder}${imgName}`}
      alt={`${model.name}, ${color.name}`}
    />
  );
}

function ColorSelector({ model, value, onColorClick, colorSelected }) {
  const imgName = `${model.key}_icons/${value}.png`;

  return (
    <img
      className={`configurator-parameters__color ${
        colorSelected.key === value ? "active" : ""
      }`}
      src={`${imgFolder}${imgName}`}
      alt={value}
      onClick={onColorClick}
    />
  );
}

function RimsSelector({ model, value, onRimsClick, rimsSelected }) {
  const imgName = `${model.key}_icons/rims_${value.toLowerCase()}.png`;

  return (
    <img
      className={`configurator-parameters__color ${
        rimsSelected.key === value?.toLowerCase() ? "active" : ""
      }`}
      src={`${imgFolder}${imgName}`}
      alt={value}
      onClick={onRimsClick}
    />
  );
}

export default function Exterior({ model, initColor, onChange }) {
  const [colorSelected, setColor] = useState(initColor);
  const [rimsSelected, setRims] = useState(colorSelected.rims[0]);

  function onColorClick(colorClicked) {
    const rim = colorClicked.rims.find((x) => x.key === rimsSelected.key);
    setRims(rim ? rim : colorClicked.rims[0]);

    setColor(colorClicked);
    onChange(colorClicked);
  }

  function onRimsClick(rimsClicked) {
    setRims(rimsClicked);
  }

  return (
    <>
      <div className="configurator-preview">
        <VehicleImage model={model} color={colorSelected} rim={rimsSelected} />
      </div>

      <div className="configurator-parameters-wrapper">
        <div className="carCaption">
          {colorSelected.name} {rimsSelected.name}
        </div>
        <div className="configurator-parameters">
          <div className="configurator-parameters-section">
            {model.colors.map((color) => (
              <ColorSelector
                model={model}
                value={color.key}
                key={color.key}
                onColorClick={() => {
                  onColorClick(color);
                }}
                colorSelected={colorSelected}
              />
            ))}
          </div>

          <div className="configurator-parameters-section">
            {colorSelected.rims.map((rim) => (
              <RimsSelector
                model={model}
                value={rim.key}
                key={rim.key}
                onRimsClick={() => {
                  onRimsClick(rim);
                }}
                rimsSelected={rimsSelected}
              />
            ))}
          </div>
        </div>
        <div className="carCaption"></div>
      </div>
    </>
  );
}
